import { useSelector } from 'react-redux'

import {
  selectCustomer,
  selectHasIntegrateCompanyGroup,
  selectShowChat
} from 'redux/selectors/Customer'

// hook for retreiving signed in customer
export const useCustomer = () => {
  return useSelector(selectCustomer)
}

// hook for retreiving signed in customer
export const useIsManagementCompany = () => {
  const customer = useSelector(selectCustomer)

  return !!customer?.is_management_company
}

// hook for retreiving custom has
// integrated company groups
export const useHasIntegratedCompanyGroups = () => {
  return useSelector(selectHasIntegrateCompanyGroup)
}

export const useChat = () => {
  return useSelector(selectShowChat)
}

// hook for checking if internal follow up is allowed
export const useAllowInternalFollowUp = () => {
  const customer = useSelector(selectCustomer)

  return !!customer?.allow_access?.internal_follow_up
}
